<template>
  <div class="container">
    <div class="row faqs mx-auto mb-5">
      <div class="col-md-12">
        <h1 class="text-uppercase text-center mt-5">
          {{ $t('Participating_Product.Title') }}
          <!-- Fetching title -->
        </h1>

        <div class="product-list row my-4">
          <div
            v-for="(product, index) in pproduct"
            :key="index"
            class="product-item col-md-6 text-center" 
          >
            <div class="product-img" v-html="product.img"></div>
            <!-- Render image -->
            <p class="product-name my-4" v-html="product.name"></p>
            <!-- Render name -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pproduct: [], // Initialize empty product list
    };
  },
  created() {
    this.loadpproduct(); // Load products when component is created
  },
  watch: {
    '$i18n.locale': 'loadpproduct', // Watch for language changes
  },
  methods: {
    async loadpproduct() {
      const currentLocale = this.$i18n.locale;
      try {
        const response = await fetch(`/locales/${currentLocale}.json`); // Fetch from public/locales
        const data = await response.json();
        this.pproduct = data?.Participating_Product?.pproduct || []; // Corrected path
      } catch (error) {
        console.error(`Error loading locale file for ${currentLocale}:`, error);
        this.pproduct = []; // Clear list on error
      }
    },
  },
};
</script>

